<h1 mat-dialog-title>Delete filename convention</h1>
<mat-dialog-content class="dialog-body">
  <p>
    Delete <strong>{{ data.current.name }}</strong>?
  </p>

  @if (probed) {
    @if (needsAcknowledge && warning !== null) {
      <div class="warning">
        <p class="warning-line">
          This filename convention is used by <strong>{{ warning.count }}</strong>
          output {{ warning.count === 1 ? 'formula' : 'formulas' }}.
        </p>
        @if (warning.names.length > 0) {
          <ul class="names-list">
            @for (n of warning.names; track n) {
              <li>{{ n }}</li>
            }
          </ul>
        }
        <mat-checkbox [formControl]="acknowledgeControl">
          I understand this will affect {{ warning.count }}
          {{ warning.count === 1 ? 'item' : 'items' }}
        </mat-checkbox>
      </div>
    }
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="actions">
  <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
  <button
    mat-stroked-button
    type="button"
    color="warn"
    [disabled]="!canDelete"
    (click)="confirm()"
  >
    Delete
  </button>
</mat-dialog-actions>
